import { JSX } from "solid-js";
import { classNames } from "~/utils/etc";
import "./border_gradient_telescope.css";

export function BorderGradientTelescope(props: {
  children?: JSX.Element;
  className?: string;
  contentClass?: string;
  contentStyle?: Record<string, string>;
}) {
  return (
    <div
      class={classNames(
        "rotatingGradientParentTelescope",
        `w-full ${props.className}`
      )}
    >
      {props.children}
      <div
        style={props.contentStyle}
        class={classNames(
          "rotatingGradientContentTelescope",
          props.contentClass
        )}
      ></div>
    </div>
  );
}
